import { useState } from "react";
import Amount from "../Inputs/Amount";
import { BudgetItem, BudgetType, CurrentUser, FamilyBucketLabel } from "../../types";
import { Grid } from "@mui/material";
import Toggle from "../Inputs/Toggle";
import ModalFooterSaveCancel from "./ModalFooterSaveCancel";
import ModalHeader from "./ModalHeader";
import { useSelector } from "react-redux";

const EditBudgetPeriod = (props: any) => {
	let [budget, setBudget] = useState(props.Item as BudgetItem);
	let user: CurrentUser = useSelector((state: any) => state.userData.value);

	return (<>
		<ModalHeader Title="Budget Period Goal" Close={props.Close} />
		<div className="modal-body mt-5">
			<Grid container>
				{budget.budgetType !== BudgetType.Income && <Amount Label="Spending Budget" Size={12} Value={budget.variant.amount} OnChange={(val: any) => UpdateAmount(val.target.value)} />}
				{budget.budgetType !== BudgetType.Expense && <Amount Label="Income Budget" Size={12} Value={budget.variant.incomeAmount} OnChange={(val: any) => UpdateIncomeAmount(val.target.value)} />}
				{budget.subBudgets && budget.subBudgets.length > 0 && (
					<Grid item xs={12} className="mt-4">
						<b>{`${FamilyBucketLabel(user, "subBudget", "SubBudget")}`} Amounts:</b>
						{budget.subBudgets.map((sub, idx) => (
							<Grid container spacing={1} alignItems="center" key={idx} className="mb-2">
								<Grid item xs={6}>
									<span>{sub.description || `SubBudget ${idx + 1}`}</span>
								</Grid>
								<Grid item xs={6}>
									{budget.budgetType !== BudgetType.Income && <Amount Label="Spending Budget" Size={12} Value={sub.variant?.amount ?? 0} OnChange={(val: any) => UpdateSubBudgetAmount(idx, val.target.value)} />}
									{budget.budgetType !== BudgetType.Expense && <Amount Label="Income Budget" Size={12} Value={sub.variant?.incomeAmount ?? 0} OnChange={(val: any) => UpdateSubBudgetIncomeAmount(idx, val.target.value)} />}
								</Grid>
							</Grid>
						))}
					</Grid>
				)}
				<Toggle Size={12} Label="Apply updated amount to future budget periods" OnChange={UpdateIsDefault} Checked={budget.variant.isDefault ?? false} className="mb-5" />
			</Grid>
		</div>
		<ModalFooterSaveCancel ShowSave={ShouldShowSave()} Save={() => props.OnSave(budget)} Close={props.Close} />
	</>);

	function ShouldShowSave() {
		if (!budget.description) return false;
		return true;
	}

	function UpdateAmount(newValue: string) {
		let val: number = 0;
		if (newValue) val = parseFloat(newValue);
		let variant = { ...budget.variant, amount: val };
		let item = ({ ...budget, variant: { ...variant } });
		setBudget(item);
	}
	function UpdateIncomeAmount(newValue: string) {
		let val: number = 0;
		if (newValue) val = parseFloat(newValue);
		let variant = { ...budget.variant, incomeAmount: val };
		let item = ({ ...budget, variant: { ...variant } });
		setBudget(item);
	}
	function UpdateIsDefault(event: any, newValue: boolean) {
		let variant = { ...budget.variant, isDefault: newValue };
		let item = ({ ...budget, variant: { ...variant } });
		setBudget(item);
	}
	function UpdateSubBudgetAmount(idx: number, newValue: string) {
		let val: number = 0;
		if (newValue) val = parseFloat(newValue);
		const subBudgets = budget.subBudgets!.map((sub, i) => {
			if (i !== idx) return sub;
			return {
				...sub,
				variant: {
					...sub.variant!,
					amount: val
				}
			};
		});
		setBudget({ ...budget, subBudgets });
	}
	function UpdateSubBudgetIncomeAmount(idx: number, newValue: string) {
		let val: number = 0;
		if (newValue) val = parseFloat(newValue);
		const subBudgets = budget.subBudgets!.map((sub, i) => {
			if (i !== idx) return sub;
			return {
				...sub,
				variant: {
					...sub.variant!,
					incomeAmount: val
				}
			};
		});
		setBudget({ ...budget, subBudgets });
	}
}

export default EditBudgetPeriod;